import { render, staticRenderFns } from "./V2DirectRetailerDropdown.vue?vue&type=template&id=af4dae90&scoped=true&"
import script from "./V2DirectRetailerDropdown.vue?vue&type=script&lang=js&"
export * from "./V2DirectRetailerDropdown.vue?vue&type=script&lang=js&"
import style0 from "./V2DirectRetailerDropdown.vue?vue&type=style&index=0&id=af4dae90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4dae90",
  null
  
)

export default component.exports